import ClientTaggingModal from './ClientTaggingModal';

export default ClientTaggingModal;
